// TODO
// - melhorar fetch do avatar (o MS Graph retorna um blob da imagem ao
// invés de uma URL. nesse caso foi preciso uma gambiarra para salvar
// a imagem no redux e poder renderizar nos componentes)
import { takeLatest, takeEvery, put, call, select } from 'redux-saga/effects'
import { Providers, MsalProvider } from '@microsoft/mgt'
import moment from 'moment'
import { Types } from '../ducks/auth'
import powerAppsApi from '../../services/powerapps/index'
import segiApi from '../../services/segi/index'
import { getProjectProducts } from '../ducks/technicalDep'
import oikosApi from '../../services/oikos'
import qs from 'qs'

const msalConfig = {
  auth: {
    authority: 'https://login.microsoftonline.com/b1d6354f-2d85-447a-957c-388514f82a71',
    clientId: '4fdab60d-1012-4621-852c-c7d846ae6044',
    redirectUri: process.env.REACT_APP_URL,
    postLogoutRedirectUri: 'https://www.ecossis.com/',
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  scopes: [
    'Contacts.Read',
    'User.Read',
    'User.ReadBasic.All',
    'Sites.Read.All',
    'Sites.ReadWrite.All',
    'Group.Read.All',
    'GroupMember.Read.All',
    'Calendars.Read',
    'Calendars.ReadWrite',
    'People.Read',
    'Presence.Read',
    'Presence.Read.All',
    'Mail.Send',
    'Mail.ReadWrite',
    'Files.Read',
    'Files.ReadWrite',
  ],
}

Providers.globalProvider = new MsalProvider({
  authority: msalConfig.auth.authority,
  clientId: msalConfig.auth.clientId,
  redirectUri: msalConfig.auth.redirectUri,
  postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri,
  cacheLocation: msalConfig.cache.cacheLocation,
  scopes: msalConfig.scopes,
})

// Evita que um consent incremental (redirect) de outra feature “prenda” o login do Oikos
try {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem('mgt-requested-scopes')
    const deniedRaw = sessionStorage.getItem('mgt-denied-scopes')
    if (deniedRaw) {
      const denied = JSON.parse(deniedRaw)
      if (Array.isArray(denied)) {
        const cleaned = denied.filter(s => !/OnlineMeeting/i.test(String(s)))
        if (cleaned.length) sessionStorage.setItem('mgt-denied-scopes', JSON.stringify(cleaned))
        else sessionStorage.removeItem('mgt-denied-scopes')
      }
    }
  }
} catch (e) {
  // ignore
}

const graphProvider = Providers.globalProvider
export const graphClient = graphProvider.graph.client
export { msalConfig }

function readAvatarStream(blob) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}

function* login() {
  //fetch('https://oikos.ecoss.is/oikos/_webhook_checknewusers.php')
  try {
    yield graphProvider.login()
    const user = yield graphClient.api('/me').get()

    yield put({
      type: Types.LOGIN_SUCCEEDED,
      payload: {
        user,
      },
    })

    console.tron.log('user', user)

    yield call(getAvatar)
    yield call(getSubordinates, user.mail)
    yield getUserPf(user.mail)
  } catch (err) {
    console.tron.log('Erro no login: ', err)

    yield put({
      type: Types.LOGIN_FAILED,
      payload: err.message || 'Erro no login.',
    })
  }
}

function* validateToken() {
  try {
    yield graphProvider.getAccessToken({ scopes: msalConfig.scopes })
    const user = yield graphClient.api('/me').get()
    console.tron.log('user', user)

    const avatar = yield getAvatar()
    yield call(getSubordinates, user.mail)
    const userPf = yield getUserPf(user)

    console.log('user pf from oikos', userPf)

    yield put({
      type: Types.TOKEN_VALIDATION_SUCCEEDED,
      payload: {
        user: {avatar, ...user, ...userPf},
      },
    })


  } catch (err) {
    console.tron.log(`Erro ao validar token: ${err.errorMessage || err.toString()}`)

    yield put({
      type: Types.TOKEN_VALIDATION_FAILED,
      payload: err.errorMessage || err.toString(),
    })
  }
}

function* getAvatar() {
  try {
    const avatarStream = yield graphClient.api('/me/photo/$value').get()
    const avatarStreamResult = yield call(readAvatarStream, avatarStream)
    const avatar = avatarStreamResult.replace('application/octet-stream', 'image/jpg')

    return avatar;
  } catch (err) {
    console.tron.log('Erro ao requisitar avatar: ', err)
    return null;
  }
}


function* getUserPf(userFromOffice) {
  console.log(userFromOffice)
  try {
    const userPf = yield oikosApi.get(
            `/?${qs.stringify({
              action: "get",
              table: "pf",
              data: {
                pf_emailProf: userFromOffice.mail,
              }
            })}`
          )

    return userPf.data[0];
  } catch (err) {
    console.tron.log('Erro ao pegar a pf: ', err)
    return null;
  }
}

function* getSubordinates(userEmail) {
  try {
    const body = {
      acao: 'listar_subordinados',
      user_email: userEmail,
    }

    const res = yield powerAppsApi.post('/', body, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    console.tron.log('listar_subordinados res', res)

    const body1 = {
      acao: 'obter_oikos_id',
      user_email: userEmail,
    }

    const res1 = yield powerAppsApi.post('/', body1, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    console.log('obter_oikos_id res', res1)

    yield put({
      type: Types.GET_SUBORDINATES_SUCCEEDED,
      payload: {
        isManager: res.data && res.data.length > 0,
        subordinates: res.data,
        oikos_id: res1.data,
      },
    })
  } catch (err) {
    console.tron.log('Erro ao requisitar subordinados: ', err)
    yield put({
      type: Types.GET_SUBORDINATES_FAILED,
      payload: err.message || 'Erro ao requisitar subordinados.',
    })
  }
}

function* getServerDate() {
  try {
    const formData = new FormData()
    formData.append('acao', 'horario')

    /*
    const res = yield fetch('https://oikos.ecoss.is/oikos/_api_timesheet2.php', {
    method: 'POST',
    headers: {
      'Accept': 'multipart/form-data',
      'Content-Type': 'multipart/form-data'
    },
    body: JSON.stringify({acao: 'horario'})
  });
    */

    const res = yield segiApi.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })


    const offset = new Date(res.data).getTime() - Date.now()
    moment.now = () => offset + Date.now()

    console.tron.log('server date in moment()', moment())

    yield put({ type: Types.GET_SERVER_DATE_SUCCEEDED })
  } catch (err) {
    console.tron.log('Erro ao buscar data atual: ', err)
    yield put({
      type: Types.GET_SERVER_DATE_FAILED,
      payload: err.message || 'Erro ao buscar data do servidor.',
    })
  }
}

export const authSagas = [
  takeEvery(Types.TOKEN_VALIDATION_REQUESTED, validateToken),
  takeLatest(Types.LOGIN_REQUESTED, login),
  takeLatest(Types.LOGOUT, () => graphProvider.logout()),
  takeLatest(Types.GET_AVATAR_REQUESTED, getAvatar),
  takeLatest(Types.GET_SUBORDINATES_REQUESTED, getSubordinates),
  takeLatest(Types.GET_SERVER_DATE_REQUESTED, getServerDate),
]
